import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20dramatic%20gradient%20backdrop%20with%20dark%20crimson%20and%20deep%20amber%20tones%2C%20abstract%20luxurious%20texture%2C%20soft%20light%20rays%20from%20above%2C%20cinematic%20atmosphere%2C%20elegant%20editorial%20background%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20high%20contrast%2C%20warm%20golden%20highlights&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/75"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center px-4">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          不想错过任何一个瓜？
        </h2>
        <p className="text-background-50/70 text-sm mb-8 leading-relaxed max-w-lg mx-auto">
          将黑料入口加入收藏夹，每日第一时间获取最新最热的吃瓜内容。黑料入口最新地址永久有效，随时随地畅享吃瓜乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/hot"
            className="px-8 py-3 bg-accent-500 text-background-50 font-semibold rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            立即浏览热门
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 text-background-50 font-medium rounded-full hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm border border-background-50/20"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}